const PageLang = {
    get: function () {
        let langElement = document.getElementsByTagName("html")[0].attributes.lang;

        if (langElement) {
            return langElement.value;
        } else {
            return "pl";
        }
        //
        //return document.getElementsByTagName("html")[0].attributes.lang.value;
    }
};

export default PageLang;
